<template>
  <div>
    <div class="consignment-package">
      <h5 class="mb-1 font-weight-bolder">
        {{ title }}
      </h5>

      <div class="mb-2">
        <h5 class="mb-1 font-weight-bold">
          {{ t('Dimensions') }}
        </h5>
        <b-row>
          <b-col md="4" lg="3">
            <b-form-group label-for="consignee_postal_code">
              <div class="d-flex form-group-label">
                <label for="name">{{ t('Weight (kg)') }}</label>
              </div>
              <b-form-input v-model="dimensions.weight" :placeholder="t('KG')" type="number" />
            </b-form-group>
          </b-col>
          <b-col md="4" lg="3">
            <b-form-group label-for="consignee_postal_code">
              <div class="d-flex form-group-label">
                <label for="name">{{ t('Width') }}</label>
              </div>
              <b-form-input v-model="dimensions.width" :placeholder="t('Width')" type="number" />
            </b-form-group>
          </b-col>
          <b-col md="4" lg="3">
            <b-form-group label-for="consignee_postal_code">
              <div class="d-flex form-group-label">
                <label for="name">{{ t('Length') }}</label>
              </div>
              <b-form-input v-model="dimensions.length" :placeholder="t('Length')" type="number" />
            </b-form-group>
          </b-col>
          <b-col md="4" lg="3">
            <b-form-group label-for="consignee_postal_code">
              <div class="d-flex form-group-label">
                <label for="name">{{ t('Height') }}</label>
              </div>
              <b-form-input v-model="dimensions.height" :placeholder="t('Height')" type="number" />
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <div class="consignment-package-informations font-small-3">
        <text-line :title="t('Package Type')" :value="getPackageTypeName(data.package_type)" />
        <text-line :title="t('Post Type')" :value="getPostTypeName(data.post_type)" />
        <text-line :title="t('Quantity')" :value="data.quantity" />
      </div>

      <ConsignmentPackageItems
        :items="data.items"
        :check-box-status="checkBoxStatus"
        class="mt-1"
      />
      <div class="d-flex justify-content-end align-items-end mt-2">
        <b-button variant="primary" type="submit" :disabled="submitting" @click="saveDimensions()">
          {{ t('Save') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BFormInput, BFormGroup, BButton } from 'bootstrap-vue';
import useService from '@/auth/service/useService';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import TextLine from '@/components/TextLine.vue';
import ConsignmentPackageItems from '@/components/ConsignmentPackageItems.vue';

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BButton,

    TextLine,
    ConsignmentPackageItems
  },
  mixins: [helper],
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: null
    },
    checkBoxStatus: {
      type: Boolean,
      default: false
    },
    consignmentId: {
      type: Number
    }
  },

  data() {
    return {
      dimensions: {
        weight: '',
        width: '',
        length: '',
        height: ''
      },
      submitting: false
    };
  },

  methods: {
    saveDimensions() {
      this.submitting = true;
      useService
        .updateConsignmentDimensions(this.consignmentId, this.data.id, this.dimensions)
        .then(response => {
          if (response.status) {
            this.showSuccessMessage(
              `${response.message || this.$t('Dimensions successfully updated')}`
            );
          }
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  mounted() {
    this.dimensions = {
      width: this.data.width,
      weight: this.data.weight,
      length: this.data.length,
      height: this.data.height
    };
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style>
.consignment-package {
  padding: 15px;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
}
body.dark-layout .consignment-package {
  border-color: #3f4a6b;
}
</style>
